import { ActionTableState } from "../../action-table/action-table"
import WorktimeTable from "../../fragments/worktime-table"

function CustomerWorktime({ customerId }) {
  return (<WorktimeTable as={ActionTableState} preselectedCustomerId={customerId} />)
}

export default CustomerWorktime